import environment from '@environment';
import { MakePaymentPayloadDTO, PaymentStatusDTO } from 'core/models/account/make-payment-payload.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { PaymentRequestRedirectResponse } from './payment-dpp';

export class PSHPaymentService implements PaymentService<MakePaymentPayloadDTO> {
  public canStatusPoll = true;
  public canRefetchPoll = true;
  public canTimeoutPoll = false;

  private apiBuilder = new EndpointHelper(`${environment.UTILITY_API_URI}/paymentRedirect`);

  MakePayment(requestBody?: Partial<MakePaymentPayloadDTO>): Promise<PaymentRequestRedirectResponse> {
    const url = this.apiBuilder.createUrl('')
      .build();

    return HttpClient.GetInstance.post<unknown, PaymentRequestRedirectResponse>(url, requestBody)
      .then(
        (res) => {
          const response = res?.data;
          return {
            redirectUrl: response.redirectUrl,
            transactionId: response.transactionId,
            paymentType: `${requestBody?.paymentType}`,
            orderId: requestBody?.orderId,
          }
        },
        err => {
          return Promise.reject([
            err,
            {
              paymentType: `${requestBody?.paymentType}`,
              orderId: requestBody?.orderId
            }
          ]);
        });
  }

  PaymentStatus(country: string, orderId: string): Promise<PaymentStatusDTO> {
    const url = this.apiBuilder.createUrl('status')
      .addRouteParam(`${orderId}`)
      .build();

    return HttpClient.GetInstance.get<PaymentStatusDTO>(url)
      .then(
        (res) => {
          return res.data;
        },
        err => {
          return Promise.reject(err);
        });
  }

  RefetchPayment(orderId: string): Promise<PaymentRequestRedirectResponse> {
    const url = this.apiBuilder.createUrl('status')
      .addRouteParam(`${orderId}`)
      .addRouteParam(`checkout`)
      .build();

    return HttpClient.GetInstance.get<PaymentRequestRedirectResponse>(url)
      .then(
        (res) => {
          const response = res?.data;
          if (response?.redirectUrl) {
            return {
              redirectUrl: response.redirectUrl,
              transactionId: response.transactionId,
              orderId: orderId,
            } as PaymentRequestRedirectResponse
          }
          return Promise.reject(response)
        },
        err => {
          return Promise.reject(err);
        });
  }

  TokenLinks(req?: Partial<MakePaymentPayloadDTO>) {
    return Promise.reject(`PSHPaymentService -> TokenLinks not implemented`);
  }
}